<template>
  <div :class="['clipboard-copy', styles]" data-testid="clipboard-copy">
    <span
      v-if="showText"
      ref="copy"
      class="clipboard-copy__text"
      :class="size ? `clipboard-copy__text--${size}` : ''"
      data-testid="clipboard-text"
    >
      {{ text }}
    </span>
    <i
      v-if="!isCopied"
      class="icon-copy clipboard-copy__icon"
      data-testid="copy-icon"
      @click="copyText"
    ></i>
    <div v-if="isCopied" class="clipboard-copy__check-wrapper">
      <svg class="clipboard-copy__check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="clipboard-copy__circle" cx="26" cy="26" r="25" fill="none" />
        <path class="clipboard-copy__checkmark" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClipboardCopy',
  data: () => ({
    textCopy: '',
    isCopied: false
  }),
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: String
    },
    showText: {
      type: Boolean,
      default: true
    },
    styles: {
      type: String
    }
  },
  async mounted() {
    this.textCopy = await this.text
  },
  methods: {
    copyText() {
      this.isCopied = true
      navigator.clipboard.writeText(this.text)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    }
  }
}
</script>
<style lang="scss" scoped>
.clipboard-copy {
  &__remove-margin-start {
    margin-inline-start: 0;
  }
  align-items: center;
  display: flex;

  &__text {
    &--sm {
      font-size: 14px;
    }
    &--md {
      font-size: 16px;
    }
    &--lg {
      font-size: 24px;
    }
  }

  &__icon {
    cursor: pointer;
    display: inline-block;
    font-size: 1em;
    height: 1em;
    margin-left: 0.5em;
    width: 10px;
    @media (min-width: media('tablet-l')) {
      width: 15px;
    }
  }

  &__check-wrapper {
    align-items: center;
    justify-content: center;
    margin-left: 0.5em;
  }

  &__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  &__check {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;
  }
  &__checkmark {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%,
    100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }
  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px #7ac142;
    }
  }
}

html[dir='rtl'] {
  @media (max-width: 772px) {
    .clipboard-copy {
      margin-right: 0rem;
    }
  }
}
</style>
